module.exports = __webpack_public_path__ + "posture/static/img/spine_sideway_normal.df562a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/spine_sideway_normal.png
// module id = EccH
// module chunks = 1